import React, { useState, useEffect } from "react";
import {
  osName,
  browserName,
  osVersion,
  browserVersion,
  deviceType,
} from "react-device-detect";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { addSSHHSuccess } from "../features/sshhSlice";
import { addAsistSuccess } from "../features/asistSlice";
import { BACKEND } from "../config/configEnvs";
import { toast } from "react-toastify";
import { FaClosedCaptioning, FaPlus, FaUserClock } from "react-icons/fa";
import Button from '@mui/material/Button';
import Modal from "../components/ui/Modal";
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { FormatMinutesToHours } from "../utils/FormatDate";
import { CrearIncidencia } from "../utils/automateFuncions/CrearIncidencia"

function MarcarAsistencia() {

  const user = useSelector((state) => state.auth.user); // Usuario del estado global

  const today = new Date()
  .toLocaleDateString("es-ES", { weekday: "long" })
  .normalize("NFD") // Descompone caracteres acentuados
  .replace(/[\u0300-\u036f]/g, "") // Elimina los diacríticos (tildes)
  .toLowerCase();

  const userScheduleForToday = user.horarios.find((d) => d.dia.toLowerCase() === today )

  let minutosPorTrabajar = 0

  if (userScheduleForToday) {
    
    const { horaEntrada, horaSalida } = userScheduleForToday

    const [hEntrada, mEntrada] = horaEntrada.split(":").map(Number);
    const [hSalida, mSalida] = horaSalida.split(":").map(Number);

    minutosPorTrabajar = (hSalida - hEntrada) * 60 + (mSalida - mEntrada);

    if (new Date().getDay() !== 6) {
      minutosPorTrabajar -= 60;
    }
  }
  
  const dispatch = useDispatch(); // Instancia de dispatch
  const navigate = useNavigate(); // Instancia de navigate

  const [openModalReport, setOpenModalReport] = useState(false) // Estado del modal de reporte del día

  // Obtenemos las tareas del local storage
  const tasksWorkedFromLS = JSON.parse(localStorage.getItem("tasksWorked"))
  const adminTasksWorkedFromLS = JSON.parse(localStorage.getItem("adminTasksWorked"))

  const taskWorkedFromLSList = tasksWorkedFromLS?.map((task) => task.task)
  const adminTasksWorkedFromLSList = adminTasksWorkedFromLS?.map((task) => task.task)

  const [workedTasks, setWorkedTasks] = useState([]) // Tareas trabajadas

  const [dayReportText, setDayReportText] = useState("") // Texto del reporte del día

  const [dayReportArray, setDayReportArray] = useState([]) // Array de tareas trabajadas en el día

  const hasEmptyTask = (dayReportArray) => {
    return dayReportArray.some((r) => r.text?.trim().length < 5);
  };

  const hasNoTimeTask = (dayReportArray) => {
    return dayReportArray.some((r) => r.time < 2);
  };

  const totalMinutes = dayReportArray.reduce((acc, item) => acc + item.time, 0)

  const addTaskField = () => { // Añadir campo de tarea al reporte
    const newTask = { text: "", time: 0 }
    setDayReportArray(prevArray => [...prevArray, newTask])
  }

  const handleChangeValue = (index, name, value) => { // Cambiar el valor del ítem en el array
    setDayReportArray((prevArray) =>
      prevArray.map((task, i) =>
        i === index ? { ...task, [name]: name === 'time' ? Number(value) : value } : task
      )
    );
  };

  const handleRemoveTask = (index) => { // Remover una tarea
    setDayReportArray((prevArray) => prevArray.filter((_, i) => i !== index))
  }

  const currentTime = new Date().toISOString(); // Hora actual para el reporte del día

  const pauseTasksWorked = async () => { // Pausar todas las tareas que estén en proceso en ese momento
    try {
      if (workedTasks && workedTasks.length > 0) {
        const updatePromises = workedTasks.map(async (task) => {
          const eventsList = task.taskEvents;
          const lastEvent = eventsList[eventsList.length - 1];
  
          // Verifica si el último evento es "inProcess"
          if (lastEvent && lastEvent.type === "inProcess") {
            const newEvent = {
              type: "standBy",
              timeStamp: currentTime,
            };
  
            // Crea una solicitud de actualización para esta tarea
            return axios.put(`${BACKEND}/api/tareasProyectos/${task.id}`, {
              taskEvents: [...eventsList, newEvent],
            });
          }
        });
  
        // Ejecuta todas las solicitudes en paralelo y espera a que todas terminen
        await Promise.all(updatePromises);
      }
    } catch (error) {
      return null
    }
  };

  function calculateTotalTime(taskEvents) { // Sumatoria de eventos en la tarea
    if (!Array.isArray(taskEvents) || taskEvents.length < 2) {
        return 0; // Si no hay suficientes eventos, no hay tiempo que calcular.
    }

    let totalTime = 0;
    let startTime = null;

    for (let i = 0; i < taskEvents.length; i++) {
        const current = taskEvents[i];

        if (current.type === "inProcess") {
            startTime = new Date(current.timeStamp);
        } else if (current.type === "standBy" && startTime) {
            const endTime = new Date(current.timeStamp);
            totalTime += endTime - startTime; // Suma la diferencia de tiempo en milisegundos.
            startTime = null; // Reinicia el tiempo de inicio.
        }
    }
    const totalMinutes = totalTime / 60000;
    return Math.ceil(totalMinutes);
  }

  const getTasksWorked = async () => { // Obtener las tareas trabajadas en el día
    try {
      if (taskWorkedFromLSList && taskWorkedFromLSList.length > 0) {
        const response = await axios.get(`${BACKEND}/api/tareasProyectos`, {
          params: {
            where: {
              id: { in: taskWorkedFromLSList }
            },
            limit: 0,
            depth: 7
          },
        })
        setWorkedTasks(response.data.docs)
        if (response.data.docs.length > 0) {
          const arrayWithRequiredValues = response.data.docs.map((register) => {
            return {
              text: `${register.task.name} / ${register.objective.phase.service.servicio.name} / ${register.objective.phase.service.cotizacion.cliente.nombreComercial}`,
              time: calculateTotalTime(register.taskEvents)
            }
          })
          setDayReportArray((prevArray) => [...prevArray, ...arrayWithRequiredValues]);
        }
      }
    } catch (error) {
      console.log(error)
    }
  }  

  const getAdminTasksWorked = async () => { // Obtener las tareas de administración trabajadas en el día
    try {
      if (adminTasksWorkedFromLS && adminTasksWorkedFromLS.length > 0) {
        const response = await axios.get(`${BACKEND}/api/tareasAdministracion`, {
          params: {
            where: {
              id: { in: adminTasksWorkedFromLSList }
            },
            limit: 0
          }
        })
        if (response.data.docs.length > 0) {
          const arrayWithRequiredValues = response.data.docs.map((register) => {
            return {
              text: `${register.task}`,
              time: 0
            }
          })
          setDayReportArray((prevArray) => [...prevArray, ...arrayWithRequiredValues]);
        }
      }
    } catch (error) {
      console.log(error)
      toast.error("Error obteniendo las tareas administradas");
    }
  }  

  const formatDate = (date) => { // Formatear la fecha actual
    const d = new Date(date);
  
    const daysOfWeek = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
    const monthsOfYear = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio", 
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];
  
    const dayOfWeek = daysOfWeek[d.getDay()];  // Día de la semana
    const day = String(d.getDate()).padStart(2, '0');  // Día con 2 dígitos
    const month = monthsOfYear[d.getMonth()];  // Nombre del mes
    const year = d.getFullYear();  // Año completo
    const hours = String(d.getHours()).padStart(2, '0');  // Hora con 2 dígitos
    const minutes = String(d.getMinutes()).padStart(2, '0');  // Minutos con 2 dígitos
  
    return `${dayOfWeek}, ${day} de ${month}, ${year} - ${hours}:${minutes}`;
  };

  const [fecha, setFecha] = useState("");
  const [fechaSSHH, setFechaSSHH] = useState("");
  const [direccionIP, setDireccionIP] = useState("");
  const [sistemaOperativo, setSistemaOperativo] = useState("");
  const [navegador, setNavegador] = useState("");
  const [tipoDispositivo, setTipoDispositivo] = useState("");

  const [avisoSSHH, setAvisoSSHH] = useState("");
  const [accionSSHH, setAccionSSHH] = useState("");

  const [accion, setAccion] = useState(""); // Acción que continúa según la última acción registrada del usuario

  const handleClick = () => { // Manejadoor del clic de registros asistencia
    if (accion) {
      handleRegistroAsist();
    } else {
      toast.warning("Debe seleccionar una acción");
    }
  };

  const handleSaveReport = async () => {
    try {
      await axios.post(`${BACKEND}/api/reporteDiario`, {
        user: user.id,
        date: currentTime,
        totalTime: dayReportArray.reduce((acc, item) => acc + item.time, 0),
        tasksWorked: dayReportArray
      })
      pauseTasksWorked()

      localStorage.removeItem("tasksWorked")
      localStorage.removeItem("adminTasksWorked")

    } catch (error) {
      console.log(error)
      toast.error("Error guardando el registro: " + error)
    }
  }

  const [buttonLoader, setButtonLoader] = useState(false)

  const handleRegistroAsist = async () => { // Guardar el registro de 
    const currentTime = new Date().toISOString();
  
    try {
      setButtonLoader(true)
      const { data } = await axios.post(
        `${BACKEND}/api/asistencias`,
        {
          usuario: user.id,
          motivo: accion,
          fecha: currentTime,
          direccion_ip: direccionIP,
          sistema_operativo: sistemaOperativo,
          navegador: navegador,
          dispositivo: tipoDispositivo,
        },
        { withCredentials: "include" }
      );
  
      dispatch(addAsistSuccess(data.register));
      
      toast.success("Registro creado exitosamente");
      navigate("/home/registros-asistencia");
    } catch (err) {
      console.log(err);
      toast.error("Error al guardar el registro: " + err);
    } finally {
      setButtonLoader(false)
    }
  };

  const handleClickSSHH = () => { // Manejador del clic de SSHH
    if (accionSSHH) {
      setAvisoSSHH("");
      handleRegistroSSHH();
      navigate("/home/registros-sshh");
    } else {
      toast.warning("Debe seleccionar una acción");
    }
  };

  const handleRegistroSSHH = async () => { // Guardar el registro de SSHH
    const currentTime = new Date().toISOString();

    await axios
      .post(
        `${BACKEND}/api/servicioshigienicos`,
        {
          usuario: user.id,
          motivo: accionSSHH,
          fecha: currentTime,
        },
        { withCredentials: "include" }
      )
      .then(({ data }) => dispatch(addSSHHSuccess(data.register)))
      .then(() => {
        if (accionSSHH === "Entrada SSHH") {
          localStorage.setItem("accionSSHH", "Salida SSHH");
        } else if (accionSSHH === "Salida SSHH") {
          localStorage.setItem("accionSSHH", "Entrada SSHH");
        }
      })
      .catch((err) => console.log(err));
  };

  const getIPAddress = () => { // Obtener la dirección IP
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        const ipAddress = data.ip;
        setDireccionIP(ipAddress);
      })
      .catch((error) => {
        console.log("Error al obtener la dirección IP:", error);
      });
  };

  const getLastRecordAssistance = async () => {
    try {
      const response = await axios.get(
        `${BACKEND}/api/asistencias?where[usuario][equals]=${user.id}&limit=1`
      );
      const lastMotivo = response.data?.docs[0]?.motivo;
  
      const currentDate = new Date();
      const currentHour = currentDate.getHours(); // Obtén la hora actual (de 0 a 23)
      const currentDay = currentDate.getDay(); // Obtén el día de la semana (0: domingo, 6: sábado)
      let nextAction = "";
  
      const isWeekend = currentDay === 0 || currentDay === 6; // Verifica si es sábado o domingo
  
      switch (lastMotivo) {
        case "Entrada Trabajo":
          if (!isWeekend && currentHour >= 12 && currentHour < 15) {
            nextAction = "Salida Almuerzo";
          } else {
            nextAction = "Salida Trabajo";
          }
          break;
        case "Salida Almuerzo":
          if (!isWeekend && currentHour >= 13 && currentHour < 15) {
            nextAction = "Entrada Almuerzo";
          } else {
            nextAction = "Salida Trabajo";
          }
          break;
        case "Entrada Almuerzo":
          nextAction = "Salida Trabajo";
          break;
        case "Salida Trabajo":
          nextAction = "Entrada Trabajo";
          break;
        default:
          nextAction = "Entrada Trabajo";
          break;
      }
  
      setAccion(nextAction);
    } catch (error) {
      toast.error("Error obteniendo los registros: " + error);
    }
  };
  

  // Funciones de arranque de componente
  
  useEffect(() => {
    getLastRecordAssistance()
    getTasksWorked()
    getAdminTasksWorked()
  }, [])

  useEffect(() => {
    getIPAddress();
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleString();
    setFecha(formattedDate);
    setFechaSSHH(formattedDate);

    const sistema = osName || "Desconocido";
    const versionSistema = osVersion || "Desconocido";
    setSistemaOperativo(`${sistema} ${versionSistema}`);

    const navegador = browserName || "Desconocido";
    const versionNavegador = browserVersion || "Desconocido";
    setNavegador(`${navegador} ${versionNavegador}`);

    const tipo = deviceType || "Desconocido";
    setTipoDispositivo(tipo);
  }, []);

  useEffect(() => {
    // Configura la fecha y otra información de dispositivo
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleString();
    setFecha(formattedDate);

    // Lógica para obtener el IP, sistema operativo y navegador
    fetch("https://api.ipify.org?format=json")
      .then(response => response.json())
      .then(data => setDireccionIP(data.ip))
      .catch(error => console.log("Error al obtener la dirección IP:", error));

    setSistemaOperativo(`${osName || "Desconocido"} ${osVersion || "Desconocido"}`);
    setNavegador(`${browserName || "Desconocido"} ${browserVersion || "Desconocido"}`);
    setTipoDispositivo(deviceType || "Desconocido");
  }, []);

  return (
    <div className="w-full flex flex-col h-screen">

      {/* Modal de reporte del día */}
      <Modal
        onClose={() => setOpenModalReport(false)}
        activeModal={openModalReport}
        title="Reporte del día"
        centered
      >
        <div className="flex flex-col gap-6">

          <div className="flex flex-col w-full gap-2">
            <div className="flex flex-row gap-2">
              <span className="font-bold text-sm">Reporte:</span>
              <span className="font-bold text-sm">{formatDate(currentTime)}</span>
            </div>
            <span className="text-sm">
              <span className="font-bold" >Horas totales: </span>
              <span className="">
                {FormatMinutesToHours(totalMinutes) + "   "} de 
                <span className={`${totalMinutes < minutosPorTrabajar ? "text-red-500" : "text-green-500"} font-semibold`}>{
                  "   " + FormatMinutesToHours(minutosPorTrabajar)}
                </span>
              </span>
            </span>
          </div>

          {dayReportArray.length > 0 && (
            <div className="flex flex-col">

              <div className="flex flex-row items-center justify-center w-full text-xs mb-2 gap-2">
                <span className="w-[60%] text-center text-gray-400">Nombre de la tarea / Servicio / Marca - {dayReportArray.length} tarea(s)</span>
                <span className="w-[30%] text-center text-gray-400">Tiempo en minutos - {totalMinutes}</span>
                <span className="w-[10%] text-center text-gray-400">Eliminar</span>
              </div>
              <div className="flex flex-col w-full gap-2">
                {dayReportArray.map((task, index) =>

                  <div key={index} className="flex flex-row gap-2 w-full">
                    <input
                      className="text-xs w-[60%] gap-4 border border-gray-200 rounded-lg px-4 py-2"
                      type="text"
                      onChange={(e) => handleChangeValue(index, 'text', e.target.value)}
                      value={task.text}
                    />

                    <input
                      className="text-xs w-[30%] gap-4 border border-gray-200 rounded-lg px-4 py-2"
                      type="number"
                      max={600}
                      min={0}
                      onChange={(e) => handleChangeValue(index, 'time', e.target.value)}
                      value={task.time}
                    />

                    <span className="w-[10%] text-center text-gray-400">                              
                      <IconButton 
                        aria-label="delete" 
                        size="small" 
                        onClick={() => handleRemoveTask(index)}
                      >
                        <DeleteIcon 
                          fontSize="inherit" 
                          color="error"
                        />
                      </IconButton>
                    </span>

                  </div>
                )}
              </div>
            </div>
          )}

          <button
            onClick={addTaskField}  // Función para subir un nuevo link
            className="flex w-full justify-center items-center gap-2 bg-white hover:bg-blue-200 transition-all duration-100 text-white px-4 py-2 rounded-lg"
          >
            <span className="text-blue-700 text-xs">Añadir tarea</span>
            <FaPlus className="text-blue-700 text-xs"/>
          </button>

          <Button 
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
            onClick={() => {
              if (dayReportArray.length < 3) {
                toast.warning("Debes registrar al menos 3 tareas");
              } else if (hasEmptyTask(dayReportArray)) {
                toast.warning("No puedes registrar tareas sin texto");
              } else if (hasNoTimeTask(dayReportArray)) {
                toast.warning("No puedes registrar tareas con el tiempo en 0")
              } else if (totalMinutes < 240) {
                toast.warning("No puedes registrar tareas con un tiempo total inferior a 240 minutos")
              } else {
                if (totalMinutes < minutosPorTrabajar) {
                  CrearIncidencia({
                    titulo: "El tiempo de trabajo no coincide con el horario",
                    comentario: `Trabajó ${totalMinutes} de ${minutosPorTrabajar} minutos`,
                    trabajador: user.id
                  });
                }
                handleSaveReport();
                handleClick();
              }}
            }
          >
            Guardar reporte del día y marcar salida
          </Button>
        </div>

      </Modal>

      {/* NavBar */}
      <div className="flex flex-col px-2 py-2 overflow-x-auto bg-gray-100">
        <div className="flex flex-col md:flex-row items-center gap-4 justify-between">
          <div className="flex items-center gap-4 p-4">
            <FaUserClock className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Asistencia</h2>
          </div>
        </div>
      </div>

      { /* Body */}
      <div className="flex flex-grow flex-row items-center justify-center">

        {/* Registros Asistencia */}
        <div className="w-full md:w-1/2 mb-8 md:px-6">

          {/* Contenedor */}
          <div className="flex flex-col items-center justify-center shadow-lg border rounded-lg border border-gray-300 transition-all duration-100 hover:bg-gray-50 max-w-xl mx-auto">
            
            <h2 className="mx-auto my-6 md:text-lg font-bold text-gray-700">
              Marcar Asistencia
            </h2>

            <div className="mx-auto flex flex-col">

              <div className="flex items-center mb-2">
                <p className="w-28 pr-2 font-semibold text-sm text-gray-700">Nombre:</p>
                <p className="text-[#ff6400] font-semibold pl-2 text-sm">{user.name}</p>
              </div>

              <div className="flex items-center mb-2">
                <p className="w-28 pr-2 font-semibold text-sm text-gray-700">Motivo:</p>
                <select
                  value={accion}
                  className={`w-44 lg:w-48 py-2 px-2 border-none border-white text-sm bg-transparent rounded-md font-semibold ${
                    accion === "" ? "text-zinc-700" : "text-[#ff6400]"
                  }`}
                  onChange={(e) => setAccion(e.target.value)}
                  disabled
                >
                  <option value={accion}>{accion}</option>
                </select>
              </div>

              <div className="flex items-center mb-2">
                <p className="w-28 pr-2 font-semibold text-sm text-gray-700">Fecha y hora:</p>
                <p className="text-[#ff6400] font-semibold pl-2 text-sm">{fecha}</p>
              </div>
            </div>

            <div className="mx-auto flex items-center py-8">
              <Button 
                variant="contained"
                disabled={buttonLoader}
                sx={{
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  paddingBlock: "8px",
                  paddingInline: "24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => {
                  accion === "Salida Trabajo" ? setOpenModalReport(true) : handleClick()
                }}
              >
                Registrar
              </Button>
            </div>

          </div>

          <div className="w-full flex my-4">

            <Link
              to="/home/registros-asistencia"
              className={`mx-auto`}
            >
              <Button 
                variant="contained"
                sx={{
                  fontWeight: "light",
                  fontFamily: "poppins",
                  paddingBlock: "8px",
                  color: "black",
                  paddingInline: "24px",
                  backgroundColor: "#f0f0f0",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "5px",
                  '&:hover': {
                    backgroundColor: "#e7e7e7",
                  }
                }}
              >
                Registros Asistencia
              </Button>
            </Link>
          </div>
        </div>
        
        {/* Registro de SSHH */}
        <div className="w-full md:w-1/2 mb-8 md:px-6">

          {/* Contenedor */}
          <div className="flex flex-col items-center justify-center shadow-lg border rounded-lg border border-gray-300 transition-all duration-100 hover:bg-gray-50 max-w-xl mx-auto">

            <h2 className="mx-auto my-6 md:text-lg font-bold text-gray-700">
              SSHH
            </h2>

            <div className="mx-auto flex flex-col">

                <div className="flex items-center mb-2">
                  <p className="w-28 pr-2 font-semibold text-sm text-gray-700">Nombre:</p>
                  <p className="text-[#ff6400] font-semibold pl-2 text-sm">{user.name}</p>
                </div>

                <div className="flex items-center mb-2">
                  <p className="w-28 pr-2 font-semibold">Motivo:</p>
                  <select
                    value={accionSSHH}
                    className={`w-44 lg:w-48 py-2 px-2 border-none border-white text-sm bg-transparent rounded-md font-semibold hover:cursor-pointer ${
                      accionSSHH === "" ? "text-zinc-700" : "text-[#ff6400]"
                    }`}
                    onChange={(e) => setAccionSSHH(e.target.value)}
                  >
                    <option className="text-zinc-700" value="">
                      Seleccionar acción
                    </option>
                    <option value="Salida SSHH">Salida SSHH</option>
                    <option value="Entrada SSHH">Entrada SSHH</option>
                  </select>
                </div>

                <div className="flex items-center mb-2">
                  <p className="w-28 pr-2 font-semibold text-sm text-gray-700">Fecha y hora:</p>
                  <p className="text-[#ff6400] font-semibold pl-2 text-sm">{fechaSSHH}</p>
                </div>
            
              <div className="mx-auto flex items-center py-8">
                <Button 
                  variant="contained"
                  sx={{
                    fontWeight: "bold",
                    fontFamily: "poppins",
                    paddingBlock: "8px",
                    paddingInline: "24px",
                    backgroundColor: "#ff6400",
                    transform: "all",
                    animationDuration: "1000",
                    textTransform: "none",
                    borderRadius: "8px",
                    '&:hover': {
                      backgroundColor: "#bb4a03",
                    }
                  }}
                  onClick={() => {
                    handleClickSSHH();
                  }}
                >
                  Registrar
                </Button>
              </div>
            </div>
            {avisoSSHH && <p className="text-red-500 mx-auto">{avisoSSHH}</p>}
          </div>

          <div className="w-full flex my-4">
            <Link
              to="/home/registros-sshh"
              className={`mx-auto`}
            >
              <Button 
                variant="contained"
                sx={{
                  fontWeight: "light",
                  fontFamily: "poppins",
                  paddingBlock: "8px",
                  color: "black",
                  paddingInline: "24px",
                  backgroundColor: "#f0f0f0",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "5px",
                  '&:hover': {
                    backgroundColor: "#e7e7e7",
                  }
                }}
              >
                Registros SSHH
              </Button>
            </Link>
          </div>

        </div>

      </div>

    </div>
  );
}

export default MarcarAsistencia;
